export const signInFormSelector = 'form[data-amplify-authenticator-signin]';

export const isValidSignInEmail = (value: string): boolean => {
  const trimmed = value.trim();
  if (trimmed === '') {
    return false;
  }
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
};

export const applySignInEmailFieldError = (input: HTMLInputElement) => {
  input.setAttribute('aria-invalid', 'true');
  input.style.borderColor = '#d32f2f';
};

export const clearSignInEmailFieldError = (input: HTMLInputElement) => {
  input.removeAttribute('aria-invalid');
  input.style.borderColor = '';
};

export const getSignInUsernameInputElement = (): HTMLInputElement | null => {
  if (typeof document === 'undefined') {
    return null;
  }
  const form = document.querySelector<HTMLFormElement>(signInFormSelector);
  if (!form) {
    return null;
  }
  return form.querySelector<HTMLInputElement>('input[name="username"]');
};
